import { BaseService } from '../../../../../core/services/base.service';
import { CandidateFile } from '../../candidate/models/candidates.model';

export class CandidatesFilesService {
  static async GetFiles(candidateId: string): Promise<CandidateFile[]> {
    try {
      return await BaseService.Get(`/candidates/${candidateId}/files`);
    } catch (error) {
      console.error('Error fetching candidate files:', error);
      throw error;
    }
  }

  static async UploadFile(
    candidateId: string,
    file: File,
    fileType: string = "DOCUMENT" 
  ): Promise<CandidateFile> {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", fileType);

      return await BaseService.Post(
        `/candidates/${candidateId}/files`,
        formData
      );
    } catch (error) {
      console.error("Error uploading candidate file:", error);
      throw error;
    }
  }



  static async DownloadFile(candidateId: string, fileId: string): Promise<Blob> {
    try {
      return await BaseService.Blob('GET', `/candidates/${candidateId}/files/${fileId}`);
    } catch (error) {
      console.error('Error fetching candidate file:', error);
      throw error;
    }
  }

  static async DeleteFile(candidateId: string, fileId: string): Promise<void> {
    try {
      await BaseService.Delete(`/candidates/${candidateId}/files/${fileId}`);
    } catch (error) {
      console.error('Error deleting candidate file:', error);
      throw error;
    }
  }
}
